import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Form, Field } from 'react-final-form'

import { required } from '../../utils/validation'
import { useWithAuth } from '../../containers/App'
import { isEmptyObject } from '../../utils/isEmptyObject'
import TextInput from '../../components/TextInput/index'
import Select from '../../components/Select/index'
import { useNotifications } from '../../containers/Notifications'
import Modal from '../../containers/Modal'
import Button from '../../components/Button'
import { flexBoxStyles } from '../../components/Flexbox'

export const UsersModal = ({ onClose, modalReady, onSubmit, unitId }) => {
  const { notify } = useNotifications()
  const [usersData, setUsersData] = useState({})
  const withAuth = useWithAuth()
  const fetchUsers = async () => {
    const result = await withAuth(`/user/rest/user/search`, {
      method: 'POST',
      payload: {
        filters: { unitId: unitId, roleName: 'diagnostician' },
        //TODO infinite scroll
        meta: {
          limit: 500,
          page: 0,
          sorts: [],
        },
      },
    })
    return result
  }

  const fetchData = async () => {
    try {
      const resultUsers = await fetchUsers()
      setUsersData(resultUsers)
    } catch {
      notify('Nie udało się pobrać użytkowników', 'error')
    }
  }

  useEffect(() => {
    fetchData()
  }, [])
  return (
    !isEmptyObject(usersData) && (
      <Modal
        isOpen={!isEmptyObject(modalReady)}
        onClose={onClose}
        closer={true}
        title={<H1>Wybierz diagnostę</H1>}
      >
        <Form onSubmit={onSubmit}>
          {({ handleSubmit }) => (
            //TODO add select with infinite scroll
            <>
              <Field
                component={Select}
                options={usersData.models
                  .map((user) => user)
                  .map((person) => ({
                    value: [person.id],
                    label: `${person.firstName} ${person.lastName}`,
                  }))}
                label="Imię i nazwisko"
                aria-label={"Imię i nazwisko"}
                name="diagnosticianId"
                validate={required}
                width="400"
              />
              <Footer justify="space-between">
                <Button
                  onClick={() => onClose()}
                  label="Anuluj"
                  color="white"
                />
                <StyledButton
                  label="Zapisz"
                  type="submit"
                  onClick={handleSubmit}
                />
              </Footer>
            </>
          )}
        </Form>
      </Modal>
    )
  )
}

const H1 = styled.h1`
  font-weight: 400;
  margin-bottom: 5rem;
`

const Footer = styled.div`
  width: 100%;
  display: flex;
`

const StyledButton = styled(Button)`
  margin-left: 20px;
`

export default UsersModal
